// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import '../mock/index.js'

import 'babel-polyfill'
import './utils/lib/index'
import './utils/lib/wxLogin'
import { mixInit } from './utils/mixInit'
import Vue from 'vue'
import ElementUI from 'element-ui'
// import './assets/css/element-variables.scss'
import router from './router'
import store from './store'
import axios from './utils/ajax'
import { VueAxios } from './utils/request'
import App from './App'
// require('./assets/css/default.scss')
// require('./assets/css/element-rewrite.scss')
// require('./assets/css/pagesCommon.scss')
import './assets/css/index.scss'
import '@/assets/iconfont/iconfont.css'
import '@/assets/userIconfont/iconfont.css'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

import { HexLib } from '@/utils/hexLib'

// import clipboard from 'clipboard';

mixInit(Vue)
// import VueClipboard from 'vue-clipboard2'

// Vue.use(VueClipboard)
Vue.use(preview)

Vue.use(HexLib)

import './core/lazy_use'


Vue.use(VueAxios)

// Vue.prototype.clipboard = clipboard;


console.log('版本号：1.0.0', window.location.host)
// 注册组件到Vue
Vue.prototype.$axios = axios
Vue.use(ElementUI)

Vue.config.productionTip = false
// 全局导航钩子
router.beforeEach((to, from, next) => {
  if (to.name) {
    // console.log(to.path)
    let uid = localStorage.uid
    if (uid) {
      next();
    } else {
      // console.log(to)
      if (to.path === '/wx-public/xcx-edit') {
        next();
      } else {
        next({
          path: '/login/znw',
          query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
      }

    }
  } else {
    next();
  }
  // next();
})
if (1) {
  // 生产环境
  localStorage.setItem('host', 'https://user.farmtruth.com');
  localStorage.setItem('component_appid', 'wxd84cf3087972889d');
} else {
  //测试环境
  localStorage.setItem('host', 'http://zgltest1.vatrue.com');
  localStorage.setItem('component_appid', 'wxce97e91b2865f513');
}

new Vue({
  axios,
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js